import React, { useEffect, useState } from "react";
import slugify from "slugify";

import moment from "moment";
import "moment/locale/cs";
import momentLocalizer from "react-widgets-moment";
import DateTimePicker from "react-widgets/lib/DateTimePicker";

import "react-widgets/dist/css/react-widgets.css";
import style from "./form.module.sass";
import cx from "classnames";
import accounting from "accounting";
import Img from "gatsby-image";
import CoinSpinner from "../EshopProducts/CoinSpinner";
import { EIGHTEEN_YEARS_AGO } from "../../constants";

moment.locale("cs");
momentLocalizer();
const MAX_DATE_LENGTH = 12;

export const CustomInputComponent = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors },
    ...props
}) => {
    const inputClasses = cx({
        [style.group]: true,
    });

    return (
        <div className={inputClasses}>
            <label className={style.label} htmlFor={slugify(props.label)}>
                <span>{props.label}</span>
            </label>
            <div className={style.control}>
                <input
                    type={props.type ? props.type : "text"}
                    {...field}
                    {...props}
                    id={slugify(props.label)}
                />
                {touched[field.name] && errors[field.name] && (
                    <div className={style.error}>{errors[field.name]}</div>
                )}
            </div>
        </div>
    );
};

export const CustomCompanyComponent = ({
    field,
    form: { touched, errors, setFieldValue, setFieldError },
    getAresData,
    validateIco,
    ...props
}) => {
    const inputClasses = cx({
        [style.group]: true,
    });

    const [vatError, setVatError] = useState(false);

    useEffect(() => {
        if (field.value && validateIco(field.value)) {
            let result = getAresData(field.value);
            result.then(value => {
                if (value.vat_payer == "false") {
                    setVatError(true);
                    setFieldError(
                        field.name,
                        "Objednat na firmu lze pouze pro plátce DPH"
                    );
                }
                value.tin ? setFieldValue("vatNumber", value.tin) : "";
                value.company
                    ? setFieldValue("companyName", value.company)
                    : "";
            });
        }
    }, [field.value]);

    return (
        <div className={inputClasses}>
            <label className={style.label} htmlFor={slugify(props.label)}>
                <span>{props.label}</span>
            </label>
            <div className={style.control}>
                <input
                    type="text"
                    {...field}
                    {...props}
                    id={slugify(props.label)}
                />
                {touched[field.name] && errors[field.name] && (
                    <div className={style.error}>{errors[field.name]}</div>
                )}
                {vatError && (
                    <div className={style.error}>
                        Objednat na firmu lze pouze pro plátce DPH
                    </div>
                )}
            </div>
        </div>
    );
};

// Input feedback
export const InputFeedback = ({ error }) =>
    error ? <div className={style.error}>{error}</div> : null;

// Checkbox input
export const Checkbox = ({
    field: { name, value, onChange, onBlur },
    form: { errors, touched, setFieldValue },
    id,
    label,
    gdprLabel,
    contactFormCondition,
    contactFormConditionLink,
    className,
    children,
    ...props
}) => (
    <div className={style.checkbox}>
        <fieldset>
            <legend>{label}</legend>
            <div>
                <input
                    name={name}
                    id={id}
                    type="checkbox"
                    value={value}
                    checked={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className="radio-button"
                />
                {children}
            </div>
            {touched[name] && <InputFeedback error={errors[name]} />}
        </fieldset>
    </div>
);

export const RadioButtonGroup = ({
    value,
    error,
    touched,
    id,
    label,
    className,
    children,
}) => (
    <div className={style.checkGroup}>
        <fieldset>
            <legend>{label}</legend>
            <div className={style.radioGroupInline}>{children}</div>
            {touched && <InputFeedback error={error} />}
        </fieldset>
    </div>
);

// Radio input
export const RadioButton = ({
    field: { name, value, onChange, onBlur },
    id,
    label,
    ...props
}) => (
    <div className={style.radio}>
        <input
            name={name}
            id={id}
            type="radio"
            value={id} // could be something else for output?
            checked={id === value}
            onChange={onChange}
            onBlur={onBlur}
            className="radio-button"
            {...props}
        />
        <label htmlFor={id}>{label}</label>
    </div>
);

export const CalendarIcon = () => (
    <>
        <svg
            width="15"
            height="17"
            viewBox="0 0 15 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.299805 14.8156C0.299805 15.6075 0.990876 16.25 1.84266 16.25H13.1569C14.0087 16.25 14.6998 15.6075 14.6998 14.8156V6.68745H0.299805V14.8156ZM10.5855 8.95854C10.5855 8.76132 10.7591 8.59995 10.9712 8.59995H12.2569C12.4691 8.59995 12.6427 8.76132 12.6427 8.95854V10.1539C12.6427 10.3511 12.4691 10.5125 12.2569 10.5125H10.9712C10.7591 10.5125 10.5855 10.3511 10.5855 10.1539V8.95854ZM10.5855 12.7835C10.5855 12.5863 10.7591 12.425 10.9712 12.425H12.2569C12.4691 12.425 12.6427 12.5863 12.6427 12.7835V13.9789C12.6427 14.1761 12.4691 14.3375 12.2569 14.3375H10.9712C10.7591 14.3375 10.5855 14.1761 10.5855 13.9789V12.7835ZM6.47123 8.95854C6.47123 8.76132 6.6448 8.59995 6.85695 8.59995H8.14266C8.3548 8.59995 8.52838 8.76132 8.52838 8.95854V10.1539C8.52838 10.3511 8.3548 10.5125 8.14266 10.5125H6.85695C6.6448 10.5125 6.47123 10.3511 6.47123 10.1539V8.95854ZM6.47123 12.7835C6.47123 12.5863 6.6448 12.425 6.85695 12.425H8.14266C8.3548 12.425 8.52838 12.5863 8.52838 12.7835V13.9789C8.52838 14.1761 8.3548 14.3375 8.14266 14.3375H6.85695C6.6448 14.3375 6.47123 14.1761 6.47123 13.9789V12.7835ZM2.35695 8.95854C2.35695 8.76132 2.53052 8.59995 2.74266 8.59995H4.02838C4.24052 8.59995 4.41409 8.76132 4.41409 8.95854V10.1539C4.41409 10.3511 4.24052 10.5125 4.02838 10.5125H2.74266C2.53052 10.5125 2.35695 10.3511 2.35695 10.1539V8.95854ZM2.35695 12.7835C2.35695 12.5863 2.53052 12.425 2.74266 12.425H4.02838C4.24052 12.425 4.41409 12.5863 4.41409 12.7835V13.9789C4.41409 14.1761 4.24052 14.3375 4.02838 14.3375H2.74266C2.53052 14.3375 2.35695 14.1761 2.35695 13.9789V12.7835ZM13.1569 2.86245H11.6141V1.42808C11.6141 1.16511 11.3827 0.949951 11.0998 0.949951H10.0712C9.78838 0.949951 9.55695 1.16511 9.55695 1.42808V2.86245H5.44266V1.42808C5.44266 1.16511 5.21123 0.949951 4.92838 0.949951H3.8998C3.61695 0.949951 3.38552 1.16511 3.38552 1.42808V2.86245H1.84266C0.990876 2.86245 0.299805 3.50493 0.299805 4.29683V5.7312H14.6998V4.29683C14.6998 3.50493 14.0087 2.86245 13.1569 2.86245Z"
                fill="#AD9752"
            />
        </svg>
    </>
);

export const BirthDateInput = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors, setFieldValue },
    // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    ...props
}) => {
    const inputClasses = cx({
        [style.group]: true,
    });

    return (
        <div className={inputClasses}>
            <label className={style.label} htmlFor={slugify(props.label)}>
                <span>{props.label} *</span>
            </label>
            <DateTimePicker
                time={false}
                format="l"
                defaultView={"century"}
                views={["month", "year", "decade", "century"]}
                messages={{ dateButton: "Vyberte datum" }}
                placeholder={"DD. MM. RRRR"}
                className={style.calendarPopup}
                onKeyPress={event => {
                    if (event.target.value.length > MAX_DATE_LENGTH) {
                        event.preventDefault();
                    }
                }}
                parse={["D. M. YYYY", "D.M.YYYY", "DDMMYYYY"]}
                onChange={value => {
                    field.onChange(moment(value).format("YYYY-MM-DD"));
                    setFieldValue(field.name, value || "");
                }}
                max={EIGHTEEN_YEARS_AGO}
                value={field.value === "" ? null : moment(field.value).toDate()}
                containerClassName={style.datePicker}
                dateIcon={<CalendarIcon />}
            />
            <input
                type="hidden"
                {...field}
                {...props}
                id={slugify(props.label)}
            />
            {touched && errors[field.name] && (
                <div className={style.error}>{errors[field.name]}</div>
            )}
        </div>
    );
};

// Product Input

export const ProductInput = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    dispatch,
    price,
    image,
    ...props
}) => {
    const { stock, stockLoading, isCoinAvailable, openModal } = props;
    const inputClasses = cx({
        [style.product]: true,
        [style.productWithAlert]:
            (!stockLoading &&
                typeof stock === "string" &&
                stock.length === 0) ||
            stock === 0,
        [style.productWithAlertRight]: !isCoinAvailable(),
    });
    const amountClassNames = cx({
        [style.productAmount]: true,
        [style.productAmountRight]: !isCoinAvailable(),
    });

    useEffect(() => {
        dispatch({ type: field.name, field });
    }, [field.value]); // Only re-run the effect if count changes

    return (
        <>
            <div className={inputClasses}>
                <div className={style.productName}>
                    <Img fluid={image} className={style.image} />
                    <h2>
                        {props.title}
                        <span>{props.description}</span>
                    </h2>
                </div>
                {stockLoading ? (
                    <div className={style.productAmount}>
                        <CoinSpinner />
                    </div>
                ) : stock && stock !== 0 && stock.length !== 0 ? (
                    <div className={style.productAmount}>
                        <span
                            className={style.minus}
                            onClick={_ =>
                                setFieldValue(
                                    field.name,
                                    field.value > 0 ? field.value - 1 : 0
                                )
                            }
                        >
                            -
                        </span>
                        <span className={style.amount}>
                            <input
                                type="number"
                                {...field}
                                id={slugify(props.label)}
                                min="0"
                            />
                            <span className={style.amountLabel}>Ks</span>
                        </span>
                        <span
                            className={style.plus}
                            onClick={number =>
                                setFieldValue(field.name, field.value + 1)
                            }
                        >
                            +
                        </span>
                    </div>
                ) : (
                    <>
                        <div className={amountClassNames}>
                            <span className={style.red}>
                                Mince je <br />
                                vyprodána
                            </span>
                        </div>
                        <div
                            className={
                                isCoinAvailable()
                                    ? style.productAlert
                                    : style.productAlertRight
                            }
                        >
                            <span
                                onClick={() =>
                                    openModal(
                                        `${props.title} - ${props.description} - ${props.emissionTitle}`
                                    )
                                }
                            >
                                Zanechte nám váš kontakt, ozveme se, jakmile
                                bude mince dostupná
                            </span>
                        </div>
                    </>
                )}
                {isCoinAvailable() && (
                    <div className={style.productPrice}>
                        {price === 0
                            ? accounting.formatNumber(price, 0, " ", ",")
                            : accounting.formatNumber(price, 0, " ", ",")}
                        <span className={style.currency}>&nbsp;Kč</span>
                    </div>
                )}
            </div>
            {errors[field.name] && (
                <div className={style.error}>{errors[field.name]}</div>
            )}
        </>
    );
};
